<template>
    <div class="time-picker">
        <div class="time-picker-label main-text-color" v-if="label">
            {{ $t(label) }}
            <slot name="label" />
        </div>
        <el-time-picker
            v-model="model"
            is-range
            :clearable="false"
            range-separator="-"
            start-placeholder="00:00"
            end-placeholder="23:59"
            @change="onChange"
            value-format="HH:mm"
            format="HH:mm"
        />
        <div class="el-form-item__error" v-show="isNotValidField && !isCondition">
          {{ $t('validation.error.fieldIsRequired') }}
        </div>
    </div>
</template>
<script>
    import { TimePicker } from 'element-ui'
    const defaultValue = ['00:00', '23:59']

    export default {
        props: {
            label: {
                type: String,
                default: '' 
            },
            isClickedOnNextBtn: {
                type: Boolean,
                default: false
            },
            inputValue: {
                type: [Array],
                default: () => []
            },
            isCondition: {
                type: Boolean,
                default: false
            },
            modelData: {
                type: Object,
                default: () => ({})
            }
        },
        components: {
            [TimePicker.name]: TimePicker
        },
        data () {
            return {
                model: defaultValue
            }
        },
        mounted () {
            if (this.isCondition) {
                this.model = this.inputValue
            } else {
                const scheduleDataKey = 'ParameterTag' in this.$attrs ? this.$attrs.ParameterTag : this.$attrs.ComponentTag
                if (!this.modelData[scheduleDataKey]) {
                    this.model = defaultValue
                    this.onChange(defaultValue)
                } else {
                    this.model = this.modelData[scheduleDataKey]
                }
            }

        },
        computed: {
            isNotValidField () {
                return this.isClickedOnNextBtn && !this.model
            }
        },
        methods: {
            onChange (val) {
                const data = {
                    value: val,
                    component: this.$attrs
                }

                this.$emit('change', data)
            }
        }
    }
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor .el-range__close-icon, ::v-deep .el-date-editor .el-range__icon {
    @apply hidden;
}
::v-deep .el-date-editor {
    @apply justify-between;
}

::v-deep .el-range-editor.is-active, ::v-deep .el-range-editor.is-active:hover {
    @apply border-primary
}
.time-picker-label {
    @apply mb-2;
}
[dir="rtl"] .time-picker-label {
    @apply ml-3;
}
[dir="ltr"] .time-picker-label {
    @apply mr-3;
}
.el-form-item__error {
    @apply pt-2;
}
.time-picker {
    @apply relative;
}
</style>

<style lang="scss">
[dir="ltr"] .el-time-spinner {
    display: flex;
    flex-direction: row;
}
[dir="rtl"] .el-time-spinner {
    display: flex;
    flex-direction: row-reverse;
}
</style>>